"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerDoubleCommand = void 0;
const draw_deck_player_action_1 = require("../../actions/draw-deck-player-action");
const player_command_1 = require("./player-command");
const player_bust_single_rule_1 = require("../../game-rules/player-bust-single-rule");
const croupier_auto_deal_rule_1 = require("../../game-rules/croupier-auto-deal-rule");
const send_all_results_rule_1 = require("../../game-rules/send-all-results-rule");
const double_bet_action_1 = require("../../preprocessor-actions/double-bet-action");
const withdraw_chips_action_1 = require("../../preprocessor-actions/withdraw-chips-action");
const logic_types_1 = require("../../logic-types");
const game_rules_1 = require("../../game-rules");
const common_rules_1 = require("./common-rules");
class PlayerDoubleCommand {
    static isCommand(command) {
        return command instanceof PlayerDoubleCommand;
    }
    serializeToString() {
        return player_command_1.CommandTypes.Double;
    }
    validateCommand(context) {
        return context.gameState.isAllowed(logic_types_1.PlayerControls.Double);
    }
    executeCommand(commandHash, existingDeal, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            context.gameState.setRoundState(logic_types_1.RoundState.Transition, instant);
            const playerId = context.playerManager.getCurrentPlayerId();
            const drawDeckAction = new draw_deck_player_action_1.DrawDeckPlayerAction(context.playerManager.board, playerId);
            drawDeckAction.execute();
            [new double_bet_action_1.DoubleBetAction(), new withdraw_chips_action_1.WithdrawChipsAction()].forEach((action) => action.execute(context.playerManager, context.gameState, instant));
            yield context.dealProcessor.disclosePendingCards(commandHash, existingDeal);
            drawDeckAction.resolve();
            context.eventQueue.enqueue({
                type: "onDrawDeckPlayer",
                instant,
                payload: {
                    player: context.playerManager.playerFromId(playerId).clone(),
                    cardIndex: drawDeckAction.cardIndex,
                },
            });
            if (context.logicVersion <= 1) {
                yield this.resultRulesV1(playerId).execute(commandHash, existingDeal, instant, context);
            }
            else {
                yield this.resultRules(context, playerId).execute(commandHash, existingDeal, instant, context);
            }
            context.analyticsData.numberOfDoubles++;
        });
    }
    resultRules(context, playerId) {
        if (context.playerManager.hasSinglePlayer) {
            const playerBustRule = new player_bust_single_rule_1.PlayerBustSingleRule(playerId);
            const endRoundRule = common_rules_1.CommonRules.endRoundRules();
            // After a double command, the player can perform no further moves
            playerBustRule.setNext(endRoundRule);
            return playerBustRule;
        }
        const playerNextTurn = context.playerManager.playerNextTurn(playerId);
        if (playerNextTurn) {
            return new game_rules_1.PlayerBustForkRule(playerId, common_rules_1.CommonRules.moveNextPlayerRules(context, playerNextTurn.playerId), // Cannot use controls, so move to next player also
            common_rules_1.CommonRules.moveNextPlayerRules(context, playerNextTurn.playerId));
        }
        return new game_rules_1.PlayerBustForkRule(playerId, common_rules_1.CommonRules.endRoundRules(), common_rules_1.CommonRules.endRoundRules());
    }
    //
    // Legacy
    //
    resultRulesV1(playerId) {
        const playerBustRule = new player_bust_single_rule_1.PlayerBustSingleRule(playerId);
        const croupierAutoDealRule = new croupier_auto_deal_rule_1.CroupierAutoDealRule();
        const sendAllResultsRule = new send_all_results_rule_1.SendAllResultsRule();
        // After a double command, the player can perform no further moves
        playerBustRule.setNext(croupierAutoDealRule).setNext(sendAllResultsRule);
        return playerBustRule;
    }
}
exports.PlayerDoubleCommand = PlayerDoubleCommand;
